<span class="live-clock" [ngClass]="{ 'live-clock-bb': isBB, 'noSpace': event.clock.matchTime == 'HT' }" [textContent]="liveTime | async"></span>
